import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { AuthService } from "@bitwarden/common/abstractions/auth.service";
import { AuthenticationStatus } from "@bitwarden/common/enums/authenticationStatus";

import { GlossRoutes } from "../../../../apps/ironfly-web/src/app/models/enum/routes.enum";

@Injectable()
export class LockGuard {
  protected homepage = GlossRoutes.Views;
  protected loginpage = "login";
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  async canActivate() {
    const authStatus = await this.authService.getAuthStatus();

    if (authStatus === AuthenticationStatus.Locked) {
      return true;
    }

    const redirectUrl =
      authStatus === AuthenticationStatus.LoggedOut ? this.loginpage : this.homepage;

    return this.router.createUrlTree([redirectUrl]);
  }
}
